
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React, { useState } from "react";
import Page from "@/src/components/Page";
import AuthShell from "@/src/layouts/AuthShell";
import AuthContent from "@/src/components/AuthContent";
import AuthCard from "@/src/components/AuthCard";
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Stack,
  Text,
  useToast,
  useColorMode
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useAuth } from "@/src/contexts/AuthContext";
import { useForm } from "react-hook-form";
import { validateEmail } from "@/src/utils/validate-functions";
import useTranslation from "next-translate/useTranslation";

function ResetPassword() {
  const { t } = useTranslation();
  const {colorMode}=useColorMode();
  const router = useRouter();
  const toast = useToast();
  const auth = useAuth();
  const [linkSent, setLinkSent] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({ mode: "all" });

  const onSendClick = async (data) => {
    setLoading(true);
    const { email } = data;
    const resp = await auth.sendPasswordResetEmail(email);
    if (resp?.data?.data?.detail && resp?.data?.data?.detail !="Not found." ) {
      setLoading(false);
      setLinkSent(true);
    } else {
      setLoading(false);
      setLinkSent(false);
      toast({
        position: "top-right",
        title: t("notification:toast.error.title"),
        description: resp?.data?.data?.detail,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  return (
    <AuthShell>
      <AuthContent
        title={t("account:password_reset.page.title")}
        sub_title={t("account:password_reset.page.sub_title")}
        desc={t("account:password_reset.page.description")}
      >
        <AuthCard>
          <Heading
            fontSize={"32px"}
            fontWeight={"500"}
            lineHeight={"48px"}
            mb={"37px"}
            color={"#00B295"}
          >
            {t("account:password_reset.card.title")}
          </Heading>
          {!linkSent && (
            <Stack
              as={"form"}
              spacing={"145px"}
              errors={errors}
              {...register}
              onSubmit={handleSubmit((data) => onSendClick(data))}
            >
              <FormControl
                isRequired
                isInvalid={errors?.email && errors?.email.message}
              >
                <FormLabel color={colorMode === "light" ? "inherit" : "white"}>
                  {t("account:password_reset.card.email.name")}
                </FormLabel>
                <Input
                  borderColor={colorMode === "light" ? "inherit" : "brand.700"}
                  bg={colorMode === "light" ? "white" : "transparent"}
                  color={colorMode === "light" ? "inherit" : "white"}
                  _placeholder={{
                    color: colorMode === "light" ? "inherit" : "gray.200",
                  }}
                  _hover={{
                    bgColor: colorMode === "light" ? "white" : "transparent",
                  }}
                  id="email"
                  name={"email"}
                  w={"full"}
                  variant={"outline"}
                  autoComplete={"email"}
                  type={"text"}
                  placeholder={t(
                    "account:password_reset.card.email.placeholder"
                  )}
                  {...register("email", {
                    required: t("account:password_reset.card.email.required"),
                    validate: (email) => {
                      return validateEmail(email, t);
                    },
                  })}
                />
                {errors?.email ? (
                  <FormErrorMessage mb={8}>
                    {errors?.email && errors?.email.message}
                  </FormErrorMessage>
                ) : (
                  <FormHelperText mb={8}>
                    {t("account:password_reset.card.email.help")}
                  </FormHelperText>
                )}
              </FormControl>
              <Button
                id="send-reset-password"
                isLoading={loading}
                loadingText="Sending..."
                w={"full"}
                fontWeight={500}
                type={"submit"}
                colorScheme={"brand"}
              >
                {t("account:password_reset.card.button_text")}
              </Button>
            </Stack>
          )}
          {linkSent && (
            <Stack w={"full"} spacing={12} mt={8}>
              <Text
                w={"full"}
                as={"p"}
                fontSize={"16px"}
                textAlign={"left"}
                fontWeight={500}
				color={colorMode === "light" ? "inherit" : "white"}
              >
                {t("account:password_reset.card.send_success1")}
                {t("account:password_reset.card.send_success2")}
              </Text>
              <Button
                w={"full"}
                fontWeight={500}
                type={"button"}
                onClick={() => router.push("/account/auth")}
                colorScheme={"brand"}
              >
                {t("account:password_reset.card.continue")}
              </Button>
            </Stack>
          )}
        </AuthCard>
      </AuthContent>
    </AuthShell>
  );
}

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  return (
    <Page
      name={t("account:password_reset.page.title")}
      path="/account/reset-password"
    >
      <ResetPassword />
    </Page>
  );
};

export default ResetPasswordPage;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/account/reset-password',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  